<template>
    <header v-prefix class="#gallery-header bg-white py-2">
        <div :class="{ 'full-width': template_options.full_width }" class="row flex flex-column flex-align-start large-flex-row large-flex-align-center">
            <div class="flex flex-align-center">
                <button @click="$router.go(-1)" class="sidearm-galleries-btn --basic mr-1 type-base" :aria-label="returnAriaLabel">
                    <icon class="mr-1">sf-arrows-thick-left</icon>
                    <span>Return</span>
                </button>

                <social-share :gallery="gallery" />
            </div>

            <div class="flex flex-item-1 flex-column large-flex-row flex-align-start large-flex-align-center">
                <div v-if="gallery" v-prefix class="#gallery-header__details flex-item-1">
                    <h1>{{ gallery.title }}</h1>
                    <div>
                        <span class="text-bold">{{ gallery.sport.abbreviation }}</span>
                        &bull;
                        <span>{{ moment(gallery.date).format('MM.DD.YYYY') }}</span>
                    </div>
                </div>

                <span v-if="gallery" v-prefix class="#gallery-header__image-count sidearm-galleries-btn --primary --rounded">
                    {{ format_photo_count(gallery.image_count) }}
                </span>
            </div>
        </div>
    </header>
</template>

<script>
    import SocialShare from '@/components/SocialShare'
    import { mapState } from 'vuex'

    export default {
        props: {
            gallery: {
                type: Object,
                required: true,
                default: () => ({})
            },
            returnPage: {
                type: String,
                required: true
            }
        },

        components: {
            SocialShare
        },

        data: () => ({
            prevRoute: null
        }),

        methods: {},

        watch: {
            /*'$route': () => {
                let routeData = JSON.parse(localStorage.getItem('LS_ROUTE_KEY'));
                console.log(routeData);
            }*/
        },

        computed: {
            ...mapState([
                'template_options',
            ]),

            gallery_url() {
                const params = this.$route.params;

                return `${window.location.origin}/${params.sport_slug}/${params.gallery_slug}/${params.gallery_id}`;
            },

            returnAriaLabel() {
                return "Return to " + this.returnPage;
            }
        },
    }
</script>

<style lang="scss" scoped>
    .#{$prefix}__gallery-header {
        position: sticky;
        top: 84px;
        z-index: 90;

        @media (max-width: #{$breakpoint-large-down}) {
            position: relative;
            top: 0;

            &__details {
                margin: $spacer 0;
            }
        }
    }
</style>